import { SqButton } from "@/components/squircle-ui/button";
import { RiRefreshLine } from "@remixicon/react";
import { IconInfoCircle, IconPlaystationX } from "@tabler/icons-react";

type Props = {
  onActionClick: () => void;
  onDismissClick: () => void;
  message?: string;
  actionLabel?: string;
  variant?: "sync" | "error";
};

const ToastNotification = (props: Props) => {
  const isError = props.variant === "error";
  const message =
    props.message ??
    (isError ? "Oops, sync didn't go through." : "Updated metrics available.");
  const actionLabel = props.actionLabel ?? (isError ? "Try again" : "Sync Now");

  return (
    <div className="inline-flex p-[4px_5px] items-center gap-3 rounded-xl border border-[#E7E8E9] bg-white shadow-[0_1px_2px_-1px_rgba(0,0,0,0.10),_0_1px_3px_0_rgba(0,0,0,0.10)]">
      <div>
        <div
          className={`flex w-[30px] h-[30px] justify-center items-center rounded-[8px] shrink-0 ${
            isError ? "bg-[#FF000014]" : "bg-[rgba(42,148,244,0.08)]"
          }`}
        >
          {isError ? (
            <IconPlaystationX size={19} className="text-[#FF0000] shrink-0" />
          ) : (
            <IconInfoCircle size={19} className="text-[#2A94F4] shrink-0" />
          )}
        </div>
      </div>
      <div className="flex items-center gap-3">
        <div className="min-w-[209px]">
          <p className="mt-[2px] text-brand-primary-new text-[12px] font-medium">
            {message}
          </p>
        </div>
        <div>
          <div className="flex items-center gap-[6px]">
            <SqButton variant="fill" size="sm" onClick={props.onActionClick}>
              <RiRefreshLine size={14} className="text-white/80" />
              <span className="mt-[2px] text-white text-[11px] font-medium">
                {actionLabel}
              </span>
            </SqButton>

            <SqButton variant="outline" size="sm" onClick={props.onDismissClick}>
              <span className="text-brand-primary-800 text-[11px] font-normal">
                Dismiss
              </span>
            </SqButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ToastNotification;
